/**
 *合作方图标
 *@author xujinjiang
 *@date 2022/3/29 17:57
 */
export const PartnersIcon = [
  {
    icon: require('@/assets/img-web/huawei@2x.png'),
  },
  {
    icon: require('@/assets/img-web/wps@2x.png'),
  },
  {
    icon: require('@/assets/img-web/mukun@2x.png'),
  },
  {
    icon: require('@/assets/img-web/zxxk@2x.png'),
  },
  {
    icon: require('@/assets/img-web/hik@2x.png'),
  },
  {
    icon: require('@/assets/img-web/dahua@2x.png'),
  },
  {
    icon: require('@/assets/img-web/zhongJiaoYun@2x.png'),
  },
];
